/**
 * Исключение в логике приложения, обработчик
 * должен выдавать сообщение клиенту
 */
import emitter from '@/shared/services/emitter';
import { useSentryAsync } from '@/shared/composition/useSentryAsync';

const { captureExceptionSentry } = useSentryAsync();

export class RuntimeError extends Error {
  public payload: any = null
  constructor(message: string, payload?: any) {
    super(message);
    this.payload = payload;
  }
}

export function errorRuntime(message: string, payload?: any): never {
  throw new RuntimeError(message, payload);
}

/**
 * Врапер для автоматического пропуска ложных ситуаций в setup методе
 */
export function setupComposition(cb: Function extends (...args: any) => infer ReturnType ? ReturnType : any, defaultResult = {}) {
  return (props: any, context: any): ReturnType<any> => {
    try {
      const result = cb(props, context);
      if (result instanceof Promise) {
        throw new Error('[setupComposition] setup не может быть асинхронной функцией');
      }
      return result;
    } catch (e) {
      if (e instanceof RuntimeError) {
        setTimeout(() => {
          handleRuntimeError(e as RuntimeError);
        });
        return defaultResult;
      }

      captureExceptionSentry(e, 'внутри setupComposition');

      throw e;
    }
  };
}

/**
 * Также автопропуск рантайм ошибок, но с асинхронностью
 */
export function composition(cb: Function, defaultResult?: any, errorHandler?: (next: () => boolean, e: Error) => void) {
  return async (...args: any[]) => {
    try {
      const result = cb.apply(args);
      if (result instanceof Promise) {
        return await result;
      }
      return result;
    } catch (e: any) {
      if (errorHandler) {
        errorHandler(() => {
          if (e instanceof RuntimeError) {
            handleRuntimeError(e as RuntimeError);
            return true;
          }

          return false;
        }, e);
        return defaultResult;
      }

      if (e instanceof RuntimeError) {
        handleRuntimeError(e as RuntimeError);
        return defaultResult;
      }

      captureExceptionSentry(e, 'внутри composition');
      throw e;
    }
  };
}

export function handleRuntimeError(e: RuntimeError) {
  emitter.emit('openInfoDialog', {
    title: 'Ошибка',
    text: e.message,
    cancelText: 'хорошо',
  });
}
